import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Air } from "@air/next-icons";
import { memo } from "react";
export const PoweredByAir = /*#__PURE__*/ memo(()=>/*#__PURE__*/ _jsxs("div", {
        className: "fixed bottom-4 flex w-full items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text-16 text-pigeon-100",
                children: "Powered by"
            }),
            /*#__PURE__*/ _jsx(Air, {
                width: 43,
                className: "ml-1 text-blue-9"
            })
        ]
    }));
PoweredByAir.displayName = "PoweredByAir";
